var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthenticate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67578 9V4C1.67578 2.34315 3.01893 1 4.67578 1H10.6758C12.3326 1 13.6758 2.34315 13.6758 4V18C13.6758 19.6569 12.3326 21 10.6758 21H4.67578C3.01893 21 1.67578 19.6569 1.67578 18V13",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67578 1.5L5.67578 1.5",
    stroke: "#0D4740",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticate);
export default __webpack_public_path__ + "static/media/authenticate.9a217db9e0f6852c2bf94ddf130f2ba7.svg";
export { ForwardRef as ReactComponent };